import { render, staticRenderFns } from "./EventTotalsCard.vue?vue&type=template&id=12db55cc&scoped=true"
import script from "./EventTotalsCard.vue?vue&type=script&lang=js"
export * from "./EventTotalsCard.vue?vue&type=script&lang=js"
import style0 from "./EventTotalsCard.vue?vue&type=style&index=0&id=12db55cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12db55cc",
  null
  
)

export default component.exports